<template>
	<div>
	<!-- 面包屑导航区域 -->
	<el-breadcrumb separator-class="el-icon-arrow-right">
	  <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
	  <el-breadcrumb-item>权限管理</el-breadcrumb-item>
	  <el-breadcrumb-item>菜单管理</el-breadcrumb-item>
	</el-breadcrumb>
	<!-- 卡片试图区域 -->
	<el-card>
	  <!-- 搜索与添加区域 -->
	  <el-alert
	      title="只有一级,二级权限等级才需要配置路径和图标,三级权限等级不可编辑不可删除!"
	      type="warning"
	      show-icon
		  :closable="false"
		  style="margin-bottom: 15px;"
		  >
	    </el-alert>
		<el-row :gutter="20">
				<el-col :span="4">
					<el-button type="primary" @click="openAddmenu" v-Dclrights="32">添加菜单</el-button>
					</el-col>
		</el-row>
		<!-- 菜单列表区域 -->
		 <el-table
		      :data="menulist"
			  border
			  stripe
			  row-key="pid"
			  border
			  default-expand-all
			  :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
				  >
			  <el-table-column
			    type="index"
			   >
			  </el-table-column>
		      <el-table-column
		        prop="label"
		        label="菜单名称">
		      </el-table-column>
			  <el-table-column
			    prop="level"
			    label="权限等级">
				<template slot-scope="scope">
					<el-tag v-if="scope.row.level === '1'">一级权限</el-tag>
					<el-tag type="success" v-else-if="scope.row.level === '2'">二级权限</el-tag>
					<el-tag type="warning" v-else>三级权限</el-tag>
				</template>
			  </el-table-column>
			<!--  <el-table-column
			    prop="Fid"
			    label="父ID">
			  </el-table-column> -->
			  <el-table-column
			    prop="indexPath"
			    label="菜单路由路径">
			  </el-table-column>
			  <el-table-column
			    prop="icon"
			    label="icon图标">
			  </el-table-column>
			  <el-table-column
			    label="操作">
				<template slot-scope="scope">	
					<el-tooltip effect="dark" content="编辑" placement="top" :enterable="false">
					 	<el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.pid)" v-Dclrights="33" :disabled="scope.row.level=='3'"></el-button>
					   </el-tooltip>
					<el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
					 	<el-button type="danger" icon="el-icon-delete" size="mini" @click="removeMenuById(scope.row.pid)" :disabled="scope.row.level=='3'" v-Dclrights="34"></el-button>
					   </el-tooltip>
					</template>
			  </el-table-column>
		    </el-table>
	</el-card>
	<!-- 添加菜单的对话框 -->
	<el-dialog
	  title="添加菜单栏"
	  :visible.sync="addDialogVisible"
	  width="50%"
	  @close="addDialogClosed"
	>
	  <!-- 内容主体区域 -->
	 <el-form 
	 :rules="addFormRules"
	 ref="addFormRef"
	 :model="addForm"
	 label-width="80px">
	   <el-form-item label="菜单名称" prop="label">
	     <el-input v-model="addForm.label"></el-input>
	   </el-form-item>
	   <el-form-item label="父级菜单" prop="pid" >
	   		   <el-select v-model="addForm.pid" placeholder="请选择父级菜单" style="width: 100%;" @change="choose">
	   		       <el-option
	   		         v-for="item in fidmenulist"
	   		         :key="item.pid"
	   		         :label="item.label"
	   		         :value="item.pid"
	   				 >
	   		       </el-option>
	   		     </el-select>
	   </el-form-item>
	   <el-form-item label="权限等级" prop="levelId">
		   <el-select v-model="addForm.levelId" placeholder="请选择权限等级" style="width: 100%;">
		       <el-option
		         v-for="item in Rightlist"
		         :key="item.levelId"
		         :label="item.label"
		         :value="item.levelId">
		       </el-option>
		     </el-select>
	   </el-form-item>
	   <el-form-item label="菜单路径" prop="indexPath">
	     <el-input v-model="addForm.indexPath"></el-input>
	   </el-form-item>
	   <el-form-item label="icon图标" prop="icon">
	     <el-input v-model="addForm.icon"></el-input>
	   </el-form-item>
	   </el-form>
	  <!-- 底部区域 -->
	  <span slot="footer" class="dialog-footer">
	    <el-button @click="addDialogVisible = false">取 消</el-button>
	    <el-button type="primary" @click="addMenu">确 定</el-button>
	  </span>
	</el-dialog>
	<!-- 修改菜单的对话框 -->
	<el-dialog
	  title="修改菜单"
	  :visible.sync="editDialogVisible"
	  width="50%"
	  @close="editDialogClosed"
	>
	  <!-- 内容主体区域 -->
	 <el-form 
	 :rules="editFormRules"
	 ref="editFormRef"
	 :model="editForm"
	 label-width="80px">
	   <el-form-item label="菜单名称" prop="label">
	     <el-input v-model="editForm.label"></el-input>
	   </el-form-item>
	   <el-form-item label="父级菜单" prop="pid" >
	   		   <el-select v-model="editForm.pid" placeholder="请选择父级菜单" style="width: 100%;" @change="editchoose">
	   		       <el-option
	   		         v-for="item in fidmenulist"
	   		         :key="item.pid"
	   		         :label="item.label"
	   		         :value="item.pid"
	   				 >
	   		       </el-option>
	   		     </el-select>
	   </el-form-item>
	   <el-form-item label="权限等级" prop="levelId">
	   		   <el-select v-model="editForm.levelId" placeholder="请选择权限等级" style="width: 100%;">
	   		       <el-option
	   		         v-for="item in Rightlist"
	   		         :key="item.levelId"
	   		         :label="item.label"
	   		         :value="item.levelId">
	   		       </el-option>
	   		     </el-select>
	   </el-form-item>
	   <el-form-item label="菜单路径" prop="indexPath">
	     <el-input v-model="editForm.indexPath"></el-input>
	   </el-form-item>
	   <el-form-item label="icon图标" prop="icon">
	     <el-input v-model="editForm.icon"></el-input>
	   </el-form-item>
	   </el-form>
	  <!-- 底部区域 -->
	  <span slot="footer" class="dialog-footer">
	    <el-button @click="editDialogVisible = false">取 消</el-button>
	    <el-button type="primary" @click="editMenuInfo">确 定</el-button>
	  </span>
	</el-dialog>
		</div>
</template>

<script>
	export default{
		data(){
			return{
				menulist:[],
				//获取父级菜单
				fidmenulist:[],
				//获取权限等级
				Rightlist:[],
				//total:0,
				//控制添加菜单对话框的显示与隐藏
				addDialogVisible:false,
				//控制修改菜单对话框的显示与隐藏
				editDialogVisible:false,
				//添加用户的表单数据
				addForm:{
					label:'',
					levelId:'',
					pid:'',
					indexPath:'',
					icon:''
				},
                //添加表单的验证规则对象
				addFormRules:{
					label:[
						{required:true,message:'请输入菜单栏名称',trigger:'blur'},
						{min:2,max:10,message:'菜单栏的长度在2~10字符之间',trigger:'blur'}
					],
					levelId:[
						{required:true,message:'请选择权限等级',trigger:'change'},
					],
					pid:[
						{required:true,message:'请选择父级菜单',trigger:'change'},
					],
				},
				//查询到的菜单信息对象
				editForm:{
					id:'',
					label:'',
					levelId:'',
					pid:'',
					indexPath:'',
					icon:''
				},
				//修改表单的验证规则对象
				editFormRules:{
					label:[
						{required:true,message:'请输入菜单栏名称',trigger:'blur'},
						{min:2,max:10,message:'菜单栏的长度在2~10字符之间',trigger:'blur'}
					],
					levelId:[
						{required:true,message:'请选择权限等级',trigger:'change'},
					],
					pid:[
						{required:true,message:'请权限父级菜单',trigger:'change'},
					],
				},
			}
		},
		created(){
			this.getMenuList()
		},
		methods:{
			async getMenuList(){
				const {data:res} = await this.$http.getAllMenu()
				if (res.status !==0){
	             return this.$message.error('获取菜单列表失败!')
				}
				this.menulist = res.data
				//过滤数组因为三级权限是不允许充当父级菜单，只允许1，2级权限充当父级菜单
				const option1 = res.dataList.filter(item=>{
						return item.level !='3'
					})
				const options =[{pid:0,label: '添加没有父级菜单'}]
					//使用ES6扩展运算符…合并
					let arry = [
						...options,
						...option1
					]
				this.fidmenulist = arry
				console.log(this.fidmenulist)
			},
		
			openAddmenu(){
				this.addDialogVisible = true
			},
			choose(val){
				//VUE页面中下拉框（el-select）的change事件选中获取整个对象数据
				var obj = {}
				obj = this.fidmenulist.find(function(i){
					return i.pid === val 
				})
				//联动等级下拉框
				if(obj.level==undefined){
					this.Rightlist=[]
					this.addForm.levelId=''
					this.Rightlist.push({
					   levelId: '1',
					   label: '一级权限'
					})
				}else if(obj.level=='1'){
					 this.Rightlist=[]
					 this.addForm.levelId=''
					 this.Rightlist.push({
					    levelId: '2',
					    label: '二级权限'
					 })
				}else if(obj.level=='2'){
					    this.Rightlist=[]
						this.addForm.levelId=''
					    this.Rightlist.push({
					    levelId: '3',
					    label: '三级权限'
					 })
				}
			},
			editchoose(val){
				//VUE页面中下拉框（el-select）的change事件选中获取整个对象数据
				var obj = {}
				obj = this.fidmenulist.find(function(i){
					return i.pid === val 
				})
				//联动等级下拉框
				if(obj.level==undefined){
					this.Rightlist=[]
					this.editForm.levelId=''
					this.Rightlist.push({
					   levelId: '1',
					   label: '一级权限'
					})
				}else if(obj.level=='1'){
					 this.Rightlist=[]
					 this.editForm.levelId=''
					 this.Rightlist.push({
					    levelId: '2',
					    label: '二级权限'
					 })
				}else if(obj.level=='2'){
					    this.Rightlist=[]
						this.editForm.levelId=''
					    this.Rightlist.push({
					    levelId: '3',
					    label: '三级权限'
					 })
				}
				console.log(obj.level)
			},
			//点击按钮，添加菜单
			addMenu(){
				console.log(this.addForm)
				this.$refs.addFormRef.validate(async valid =>{
              	if (!valid) return
				 const {data:res} = await this.$http.addMenu({data:{
					 Fid:this.addForm.pid,
					 label:this.addForm.label,
					 level:this.addForm.levelId,
					 indexPath:this.addForm.indexPath,
					 icon:this.addForm.icon
				 }})
				if (res.status !==0){
					return this.$message.error('添加菜单失败!')
				}
				this.$message.success('添加菜单成功!')
				this.addDialogVisible = false
				this.getMenuList()
				})
			},
			//监听添加菜单对话框的关闭
			addDialogClosed(){
				this.$refs.addFormRef.resetFields()
				this.Rightlist=[]
			},
			//展示编辑菜单的对话框
			async showEditDialog(id){
				const {data:res} = await this.$http.byIdGetMenu(id)
				if (res.status !==0){
					return this.$message.error('查询菜单信息失败!')
				}
				this.Rightlist.push({
				   levelId:res.data.level,
				   //三目运算符，三个条件写法
				   label:res.data.level=='1'?'一级权限':(res.data.level=='2'? '二级权限':'三级权限')
				})
				 this.editForm.label = res.data.label
				 this.editForm.pid = res.data.Fid
				 this.editForm.id = res.data.pid
				 this.editForm.indexPath = res.data.indexPath
				 this.editForm.icon = res.data.icon
				 console.log(this.editForm)
				 this.editDialogVisible = true
			},
		//修改菜单信息并提交
		editMenuInfo(){
			this.$refs.editFormRef.validate(async valid =>{
			if (!valid) return
					console.log(this.editForm)
			const {data:res} = await this.$http.editMenu({data:{
			 pid:this.editForm.id,
			 Fid:this.editForm.pid,
			 label:this.editForm.label,
			 level:this.editForm.levelId,
			 indexPath: this.editForm.indexPath,
			 icon:this.editForm.icon
			}})
			if (res.status !==0){
				return this.$message.error('修改菜单失败!')
			}
			this.$message.success('修改菜单成功!')
			this.editDialogVisible = false
		    this.getMenuList()
			 })
		},
		//监听修改菜单对话框的关闭
		editDialogClosed(){
			this.$refs.editFormRef.resetFields()
			this.Rightlist=[]
		},
		//根据Id删除对应的菜单信息
		async removeMenuById(id){
			//弹框询问用户是否删除数据
			        const confirmResult = await this.$confirm('此操作将永久删除该菜单, 是否继续?', '提示', {
			          confirmButtonText: '确定',
			          cancelButtonText: '取消',
			          type: 'warning'
			        }).catch(err => err)
					if (confirmResult !== 'confirm'){
						return this.$message.info('已取消删除')
					}
					const {data:res} = await this.$http.delMenu(id)
					if (res.status !==0){
						return this.$message.error('删除菜单失败!')
					}
					this.$message.success('删除菜单成功!')
					this.getMenuList()
		},
		}
	}
</script>

<style lang="less" scoped>
</style>
